import {gql} from 'apollo-boost';

export const GET_PRIVATE_MESSAGE_REPLY = gql`
  query getPrivateMessageReply($id: ID!){
    getPrivateMessageReply(id: $id) {
      id toUserCode fromUserCode message sendDate isRead readDate
      ip isFromTeacher isFromStudent
      privateMessage { id }
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
    }
  }
`;

export const GET_PRIVATE_MESSAGE_REPLIES = gql`
  query getPrivateMessageReplyReplies($id : ID!){
    getPrivateMessageReplyReplies (
      id: $id
    ) {
      id toUserCode fromUserCode message sendDate isRead readDate
      ip isFromTeacher isFromStudent
      privateMessage { id }
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
    }
  }
`;

export const GET_PRIVATE_MESSAGE_REPLIES_BY_FILTER = gql`
  query getPrivateMessageReplyRepliesByFilter($privateMessageReplyFilterInput: PrivateMessageReplyFilterInput){
    getPrivateMessageReplyRepliesByFilter (
      privateMessageReplyFilterInput: $privateMessageReplyFilterInput
    ) {
      id toUserCode fromUserCode message sendDate isRead readDate
      ip isFromTeacher isFromStudent
      privateMessage { id }
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
    }
  }
`;

export const ADD_PRIVATE_MESSAGE_REPLY = gql`
  mutation addPrivateMessageReply(
    $privateMessageId: ID!,
    $toUserId: ID!,
    $privateMessageReplyInput: PrivateMessageReplyInput!
  ) {
    addPrivateMessageReply(
      privateMessageId: $privateMessageId
      toUserId: $toUserId
      privateMessageReplyInput: $privateMessageReplyInput
    ) {
      id toUserCode fromUserCode message sendDate isRead readDate
      ip isFromTeacher isFromStudent
      privateMessage { id }
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
    }
  }
`;

export const UPDATE_PRIVATE_MESSAGE_REPLY = gql`
  mutation updatePrivateMessageReply(
    $id: ID!,
    $privateMessageReplyInput: PrivateMessageReplyInput!
  ) {
    updatePrivateMessageReply(
      id: $id
      privateMessageReplyInput: $privateMessageReplyInput
    ) {
      id toUserCode fromUserCode message sendDate isRead readDate
      ip isFromTeacher isFromStudent
      privateMessage { id }
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
    }
  }
`;

export const UPDATE_PRIVATE_MESSAGE_REPLY_ALREADY_READ = gql`
  mutation updatePrivateMessageReplyAlreadyRead(
    $id: ID!,
  ) {
    updatePrivateMessageReplyAlreadyRead(
      id: $id
    ) {
      id toUserCode fromUserCode message sendDate isRead readDate
      ip isFromTeacher isFromStudent
      privateMessage { id }
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
    }
  }
`;

export const DELETE_PRIVATE_MESSAGE_REPLY = gql`
  mutation deletePrivateMessageReply($id: ID!) {
    deletePrivateMessageReply(
      id: $id
    ) {
      id toUserCode fromUserCode message sendDate isRead readDate
      ip isFromTeacher isFromStudent
      privateMessage { id }
      toUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
      fromUser { id code nameLocal surnameLocal nameEng surnameEng email photo }
    }
  }
`;

